import React, { ReactNode } from 'react';
import { useTheme } from 'styled-components';

import { Icon } from '../icon/icon';
import { Tooltip, TooltipProps } from '../tooltip/tooltip';

type Props = {
  content: string | ReactNode;
  placement?: TooltipProps['placement'];
  title: string;
  useGoogleTranslate?: boolean;
};

export const TooltipInfoIcon = (props: Props) => {
  const theme = useTheme();

  return (
    <Tooltip
      content={props.content}
      mainAxisOffset={22}
      placement={props.placement}
      title={props.title}
    >
      <Icon color={theme.color.blue} fixedWidth={true} icon={['fas', 'circle-info']} />
    </Tooltip>
  );
};
